import CTALink from "@/components/CTA/ctaLink";
import PromoBannerTooltip from "@/components/PromoBanner/components/PromoBannerTooltip";
import type { BasePromoBannerProps } from "@/components/PromoBanner/types";
import boldTextWithAsterisk from "@/utils/functions/boldTextWithAsterisk";

export default function PromoBannerCard({
  className,
  cta,
  ctaElement,
  description,
  discount,
  discountCode,
  endDate,
  endDatePrefix = "Offer ends",
  learnMoreLink,
  title,
  tooltip,
  useDefaultDiscountText = true,
}: BasePromoBannerProps) {
  return (
    <div
      className={`bg-primary flex flex-col h-[370px] min-w-[270px] max-w-[330px] p-4 rounded-xl mx-auto ${className}`}
    >
      <div>
        <h2 className="text-3xl text-primary-foreground mt-0 mb-4">{title}</h2>
        <p className="text-primary-foreground text-sm mb-0">
          {typeof description === "string"
            ? boldTextWithAsterisk(description)
            : description}{" "}
          {useDefaultDiscountText && !!discount && !!discountCode && (
            <>
              Get <strong>up to {discount} off</strong> with code{" "}
              <strong>{discountCode}</strong>.
            </>
          )}
        </p>
      </div>
      {ctaElement && <div className="mt-4">{ctaElement}</div>}
      {cta && !ctaElement && (
        <div className="mt-4">
          <CTALink
            type="ghost"
            className="bg-white text-base"
            label={cta.label}
            url={cta.url}
            location={cta.location}
            html_id={cta.html_id}
          />
        </div>
      )}
      <p className="text-primary-foreground text-xs mt-4 mb-0">
        {endDatePrefix} {endDate}.{" "}
        <span className="inline-block align-middle">
          <PromoBannerTooltip
            discountCode={discountCode}
            endDate={endDate}
            learnMoreLink={learnMoreLink}
            htmlContent={tooltip?.infoText ?? ""}
            size={12}
          />
        </span>
      </p>
    </div>
  );
}
